import { DeleteForever, ExpandMore, Settings } from "@material-ui/icons";
import { css } from "@emotion/react";
import styled, { ThemedCssCreator } from "../../../../../../config/emotion";
import { StyledCompProps } from "../../../../../../globalTypes/theme";

export const NotificationRow = styled.div<StyledCompProps>`
  display: flex;
  flex-direction: row;
  align-items: center;
  box-shadow: 0 1px 1px ${({ theme }) => theme.colors.bgColor};

  position: relative;
  padding-right: 4.5rem;
  min-height: 3rem;

  &:last-child {
    box-shadow: none;
  }
`;

export const DeleteIcon = styled(DeleteForever)<StyledCompProps>`
  color: ${({ theme }) => theme.colors.delete};
  cursor: pointer;
`;

export const ShowMoreLinkContainer = styled.div<StyledCompProps>`
  color: ${({ theme }) => theme.colors.secondaryColor};
  cursor: pointer;
  display: flex;
  align-items: center;
  &:hover {
    color: ${({ theme }) => theme.colors.primaryColor};
  }

  span {
    font-weight: bold;
  }
`;

export const FooterContainer = styled.div<StyledCompProps>`
  display: flex;
  position: relative;
  bottom: 0;
  width: 100%;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 5px 0;
  min-height: 30px;
  box-shadow: 0 -1px 1px ${({ theme }) => theme.colors.primaryColor};
`;

export const MoreIcon = styled(ExpandMore, {
  shouldForwardProp: (prop) => prop !== "active",
})<{ active: boolean }>`
  font-size: 20px;
  margin-left: 3px;

  ${({ active }) => active && "transform: rotate(180deg)"};
`;

export const SettingsIcon = styled(Settings)<StyledCompProps>`
  position: absolute;
  right: 5px;
  font-size: 24px;
  margin-left: auto;
  color: ${({ theme }) => theme.colors.secondaryColor};
  cursor: pointer;
`;
export const notificationMessageCss: ThemedCssCreator = (theme) => css`
  color: ${theme.colors.secondaryColor};
  text-align: left;
  font-size: 0.8rem;
  padding: 0;
  margin: 0;
`;
export const notificationContainerCss = css`
  width: 100%;
  height: auto;
  margin: 0.6rem 1.2rem;
  text-decoration: none;
  position: relative;
`;

export const innerContainerCss = css`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  cursor: pointer;
`;

export const labelWrapperCss = css`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`;

export const NotificationTitle = styled.h3`
  display: flex;
  align-items: flex-start;
  font-size: 1rem;
  text-align: left;
  padding: 0;
  margin: 0;

  color: ${({ theme }) => theme.colors.secondaryColor};

  & > span:nth-of-type(2) {
    margin-left: 0.3rem;
    padding-top: 0.1rem;
  }
`;

export const containerCss = css`
  position: relative;
  overflow-y: auto;
  text-align: center;
  line-height: 1.5;
`;

export const textContainerCss: ThemedCssCreator = (theme) => css`
  flex: 1;
  margin-left: 15px;
  color: ${theme.colors.primaryColor};
  font-size: 10px;
`;

export const FabContainer = styled.div`
  position: absolute;
  top: 0.5rem;
  right: 1rem;

  scale: 0.9;
`;
